import React from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

import {
  useExchangeTokenMutation,
  useAuthStoreActions,
  convertStateToQueryParams,
} from "@/features/shared/features/authentication";

const Callback = () => {
  const exchangeTokenMutation = useExchangeTokenMutation();

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthToken } = useAuthStoreActions();

  React.useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");

    if (!code) return;

    exchangeTokenMutation.mutate(
      {
        authorization_code: code,
        callback_url: document.location.origin + "/auth/callback",
      },
      {
        onSuccess: ({ data: accessToken }) => {
          setAuthToken(accessToken);
          if (state) {
            const queryParams = convertStateToQueryParams(state);
            if (queryParams.state === "/general/information") {
              navigate("/");
            } else {
              navigate(convertStateToQueryParams(state)?.state ?? "/");
            }
          } else {
            navigate("/");
          }
        },
        onError: () => {
          console.log("error");
          // throw new Error('Error exchanging token');
        },
      },
    );
  }, [searchParams, location]);

  return <></>;
};

export default Callback;
